<template>
	<div class="form-client">
		<button class="btn btn-sm btn-primary" ref="btnSetInitial" @click="setInitial" v-show="false">Nuevo Cliente</button>
		<button class="btn btn-sm btn-primary" ref="btnNewClient" @click="clearFormClient" v-show="false">Nuevo Cliente</button>
		<button class="btn btn-sm btn-primary" ref="btnShowClient" @click="showClientLocal" v-show="false">Buscar Cliente</button>
		<div v-if="!searchingClient">
			<div class="row">
				<div class="col-md-4 text-center">
					<img src="/img/perfil/client.png" class="client-img"/>
				</div>
				<div class="col-md-8">
					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<span for="inputName">Nombre</span>
								<input type="text" class="form-control form-control-sm" v-model='objectClient.name' placeholder="Nombres" :disabled="savingClient">
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<span for="inputName">Apellido</span>
								<input type="text" class="form-control form-control-sm" v-model='objectClient.surname' placeholder="Apellidos" :disabled="savingClient">
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							<div class="form-group">
								<span for="inputName">Fecha de nacimiento</span>
								<input type="date" class="form-control form-control-sm" v-model='objectClient.birthdate' placeholder="" :disabled="savingClient">
							</div>
						</div>
						<div class="col-md-4">
							<div class="form-group">
								<span for="inputName">Rut</span>
								<input type="text" class="form-control form-control-sm" v-model='objectClient.number_document' placeholder="12345678-9" :disabled="savingClient">
							</div>
						</div>
						<div class="col-md-4">
							<div class="form-group">
								<span for="inputName">Telefono</span>
								<input type="text" class="form-control form-control-sm" v-model='objectClient.phone' placeholder="912345678" :disabled="savingClient">
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-5">
							<div class="form-group">
								<span for="inputName">Email</span>
								<input type="email" class="form-control form-control-sm" v-model='objectClient.email' placeholder="nombre@mail.com" :disabled="savingClient">
							</div>
						</div>
						<div class="form-group col-md-4">
							<span for="inputTypeClient">Tipo de Cliente</span>
							<select id="inputTypeClient" class="form-control form-control-sm" v-model="objectClient.type_client_id" :disabled="savingClient">
								<option v-for="(item, index) in listTypesClient" :key="index" :value="item.id">{{ item.name }}</option>
							</select>
						</div>
					</div>
					<div class="row">
						<div class="col-12 text-right">
							<button type="button" class="btn btn-primary btn-sm" @click="saveClientLocal" :disabled="disabledBtnSave">Guardar</button>
						</div>
					</div>
				</div>
			</div>
			<hr>
		</div>
		<div v-else class="text-center">
			<i class="fas fa-spinner fa-spin"></i> Buscando Cliente {{ id }}
		</div>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import clients from '@/mixins/clients'
import typeClient from '@/mixins/clients/typeClient.js'

export default {
    name: 'FormClient',
	mixins: [mixin, errors, axiosAction, clients, typeClient],
	props: ['id', 'optionalDocumentNumber'],
    computed: {
		disabledBtnSave() {
			if(this.savingClient == true)
				return true
			if(this.objectClient.name.trim().length < 3 && this.objectClient.surname.trim().length < 3)
				return true
			if(this.objectClient.number_document != '' && !this.checkDigitoRUT(this.objectClient.number_document))
				return true
			if(this.optionalDocumentNumber == false && !this.checkDigitoRUT(this.objectClient.number_document))
				return true
			if(this.objectClient.email != '' && !this.isMail(this.objectClient.email))
				return true
			return false
		}
	},
	methods: {
		clearFormClient() {
			this.clearObjectClient()
		},
		getAllTypesClientResultLocal(response) {
		},
        resultAxiosLocal(responseLocal, response) {
            this.$emit('hideLockScreen')
            switch (responseLocal) {
				case 'getAllTypesClientResult': this.getAllTypesClientResult(response); break;
				case 'showClientResult': this.showClientResult(response); break;
				case 'saveClientPOSTResult': this.saveClientResult(response, responseLocal); break;
				case 'saveClientPUTResult': this.saveClientResult(response, responseLocal); break;
                default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
            }
        },
		setInitial() {
			this.getAllTypesClient()
		},
		showClientLocal() {
			if(this.id != undefined && this.id > 0) {
				this.showClient(this.id)
			}
		},
		showClientResultLocal(response) {},
		saveClientLocal() {
			this.saveClient(this.objectClient)
		},
		saveClientResultLocal(response) {
			if(response.data.success == true) {
				this.$emit('actionSaveClient', response.data)
			}
		}
	},
	mounted() {
	}

}
</script>

<style scoped lang="scss">
.form-client {
	color: #333;
	.client-img {
		width: 70%;
	}
}
</style>
